import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultOrderData = {
  id: undefined,
  orderReference: '',
  customerIP: '',
  status: '',
  orderedBy: '',
  comments: '',
  total: 0,
  shippingCharges: 0,
  taxedAmount: 0,
  discountAmount: 0,
  amountReceived: 0,
  platform: 'CRM',
  couponId: 0,
  grandTotal: 0,
  totalProducts: 0,
  totalQuantity: 0,
  orderTimestamp: '',
  invoiceAttachment: null,
  otherAttachment: null,
  dealerId: null,
  dealer: {
    id: null
  },
  dealersUserId: null,
  dealersUser: {
    id: null
  },
  agentId: null,
  agent: {
    id: null
  },
  billingAddressId: 0,
  billingAddress: {
    id: null
  },
  stateId: 0,
  state: {
    id: null
  },
  deliveryAddressId: 0,
  deliveryAddress: {
    id: null
  }
};
export const getOrders = params => request({
  url: '/orders',
  method: 'get',
  params
});
export const getOrderById = id => request({
  url: `/orders/${id}`,
  method: 'get'
});
export const updateOrder = (id, data) => request({
  url: `/orders/${id}`,
  method: 'patch',
  data
});
export const deleteOrder = id => request({
  url: `/orders/${id}`,
  method: 'delete'
});
export const createOrder = data => request({
  url: '/orders/',
  method: 'post',
  data
});
export const orderCount = data => request({
  url: '/orders/count',
  method: 'post',
  data
});
export const getStatusCount = params => request({
  url: '/orders/count/status',
  method: 'get',
  params
});
export const orderExport = data => request({
  url: '/orders/export',
  method: 'post',
  data
});
export const confirmOrder = (orderId = null) => request({
  url: '/transactions/update-order/' + orderId,
  method: 'get'
});
export const getOrderInfo = id => request({
  url: `/orders/info/${id}`,
  method: 'get'
});
export const getOrdersProducts = params => request({
  url: '/orders-products',
  method: 'get',
  params
});
export const editOrdersProducts = (id, data) => request({
  url: `/orders-products/edit/${id}`,
  method: 'patch',
  data
});
export const deleteOrderProduct = id => request({
  url: `/orders-products/delete/${id}`,
  method: 'delete'
});
export const manageOrdersProducts = data => request({
  url: '/orders-products/bulk-add',
  method: 'post',
  data
});
export const manageRating = (orderId, data) => request({
  url: `/orders-products/manage-rating/${orderId}`,
  method: 'patch',
  data
});
export const pendingPayment = userId => request({
  url: `/orders/pending-payment/${userId}`,
  method: 'get'
});
export const getDispatchList = data => request({
  url: '/orders-products/stats',
  method: 'post',
  data
});
export const getDispatchProducts = id => request({
  url: `/orders-products/pending-dispatch/${id}`,
  method: 'get'
});
export const deleteOrdersProduct = id => request({
  url: `/orders-products/${id}`,
  method: 'delete'
});
export const reviseOrder = data => request({
  url: '/orders/revise',
  method: 'post',
  data
});
export const downloadExcel = data => request({
  url: '/orders/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadProProductsExcel = () => request({
  url: '/orders/download-excel-pro-pending',
  method: 'post',
  responseType: 'blob'
});
export const cancelPartialDispatchOrders = data => request({
  url: '/orders/cancel-partial-dispatch-orders',
  method: 'post',
  data
});